<template>
  <div class='recurring-commissionplan-settings'>
    <dean-two-column-layout :title="headerTitle">
      <dean-section-title-item
          :icon="saveIcon"
          slot="title-items"
          :content="true"
          :large="true"
          @click.native="save"
      >
        Opslaan
      </dean-section-title-item>
      <div class="column" slot="left">
        <fade-transition group>
          <dean-form-row key="name" id="name" label="naam" v-model="data.name" type="text" :required-field="true"
                         :warning="$v.data.name.$error" @focus="$v.data.name.$touch()"/>
          <dean-select-form-row key="groupType" id="groupType" label="groep type"
                                placeholder="kies een groep type"
                                :value="currentlySelectedOption(data.groupType, groupTypes)" :options="groupTypes"
                                @input="valueChanged($event, 'groupType')" :warning="$v.data.groupType.$error"
                                @focus="$v.data.groupType.$touch()" :required-field="true"></dean-select-form-row>
          <dean-select-form-row key="certificate" id="certificate" label="vereist certificaat"
                                placeholder="kies een certificaat"
                                :clearable="true"
                                :value="currentlySelectedOption(data.certificate, certificates)" :options="certificates"
                                @input="valueChanged($event, 'certificate')"></dean-select-form-row>
          <dean-select-form-row v-if="show('service')" key="service" id="service" label="service"
                                placeholder="kies een service"
                                :clearable="true"
                                :value="currentlySelectedOption(data.service, services)" :options="services"
                                @input="valueChanged($event, 'service')"></dean-select-form-row>
          <dean-multi-select-form-row v-if="show('productTerms')" key="productTerms" id="productTerms" label="termijn"
                                      placeholder="kies een termijn" :multiple="true" :options="productTerms"
                                      :value="currentTerms" @select="add($event, 'productTerms')"
                                      @remove="remove($event, 'productTerms')"></dean-multi-select-form-row>
          <dean-input-switch-form-row v-if="show('foldable')" key="foldable" id="foldable" label="inklapbaar"
                                      :value="data.foldable" @checked="inputSwitchChanged"></dean-input-switch-form-row>
          <dean-input-switch-form-row v-if="show('address')" key="address" id="address" label="bestellen op adres"
                                      :value="data.address" @checked="inputSwitchChanged"></dean-input-switch-form-row>
          <dean-form-row key="order" id="order" label="order" v-model="data.order" type="text" :required-field="true"
                         :warning="$v.data.order.$error" @focus="$v.data.order.$touch()"/>
          <dean-form-row key="tags" id="tags" label="tags" v-model="data.tags" type="text"/>
          <dean-form-row v-if="show('icon')" key="icon" id="icon" label="icon" v-model="data.icon" type="text"/>
          <dean-multi-select-form-row v-if="show('partnerAgreementTypes')" key="partnerAgreementTypes"
                                      id="partnerAgreementTypes" label="Partner types"
                                      placeholder="kies een partner type" :multiple="true"
                                      :options="partnerAgreementTypes"
                                      :value="currentTypes" @select="add($event, 'partnerAgreementTypes')"
                                      @remove="remove($event, 'partnerAgreementTypes')"></dean-multi-select-form-row>
        </fade-transition>
      </div>
    </dean-two-column-layout>
  </div>
</template>

<script lang="ts">
  import {Vue, Component, Watch} from 'vue-property-decorator';
  import axios from 'axios';
  import {
    deanSectionTitleItem,
    saveIcon,
  } from '@deanone/dean-components';
  import DeanFormRow from '@/components/deanComponents/deanFormRow.vue';
  import DeanTwoColumnLayout from '@/components/deanComponents/deanTwoColumnLayout.vue';
  import deanInputSwitchFormRow from '@/components/deanComponents/deanInputSwitchFormRow.vue';
  import deanSelectFormRow from '@/components/deanComponents/deanSelectFormRow.vue';
  import deanMultiSelectFormRow from '@/components/deanComponents/deanMultiSelectFormRow.vue';
  import {FadeTransition} from 'vue2-transitions';
  import {validationMixin} from 'vuelidate';
  import {required, minValue} from 'vuelidate/lib/validators';
  import {Validations} from 'vuelidate-property-decorators';
  import {createNotification} from '@/mixins/validations';

  @Component({
    components: {
      deanInputSwitchFormRow,
      deanSectionTitleItem,
      DeanFormRow,
      DeanTwoColumnLayout,
      deanSelectFormRow,
      deanMultiSelectFormRow,
      FadeTransition,
    },
    mixins: [validationMixin],
  })
  export default class Details extends Vue {
    // DATA
    public data: any = {
      name: '',
      groupType: null,
      certificate: '',
      service: '',
      productTerms: [],
      order: '',
      tags: '',
      foldable: '',
      icon: '',
      address: '',
      partnerAgreementTypes: [],
    };
    public groupTypes: [] = [];
    public services: [] = [];
    public certificates: [] = [];
    public productTerms: [] = [];
    public partnerAgreementTypes: [] = [];
    public saveIcon: any = saveIcon;
    public groupName: string = '';

    // COMPUTED
    @Validations()
    get validations() {
      return {
        data: {
          name: {required},
          groupType: {required},
          order: {required, minValue: minValue(0)},
        },
      };
    }

    get currentTerms() {
      const terms = this.productTerms;
      const currentTerms = this.data.productTerms;
      const foundTerms: any[] = [];
      if (currentTerms != null && currentTerms.length) {
        for (const currentRole of currentTerms) {
          const foundKey: any = Object.keys(terms).find((key) =>
            // @ts-ignore-next-line
            terms[key].value === currentRole);
          foundTerms.push(terms[foundKey]);
        }
        return foundTerms;
      }
      return null;
    }

    get currentTypes() {
      const foundTypes: any[] = [];
      if (this.data.partnerAgreementTypes === null || !this.data.partnerAgreementTypes.length) {
        return null;
      }
      for (const currentValue of this.data.partnerAgreementTypes) {
        foundTypes.push(
          this.partnerAgreementTypes.find(({value}) => value === currentValue),
        );
      }
      return foundTypes;
    }

    get headerTitle(): string {
      return (this.$route.params.id !== undefined) ? 'Groep wijzigen' : 'Groep toevoegen';
    }

    get sideMenu(): object {
      return {
        content: {
          title: {
            text: 'groep ' + (this.groupName ? this.groupName : 'toevoegen'),
          },
          type: 'themed',
          sections: {
            general: {
              items: {
                backGroup: {
                  title: 'Terug naar groepen',
                  name: 'standingData.groups',
                },
                backCommissions: {
                  title: 'Terug naar periodieke commissieplannen',
                  name: 'standingData.recurringCommissionPlans',
                },
              },
            },
          },
        },
      };
    }

    // METHODS
    public currentlySelectedOption(value: any, options: any) {
      if (value !== null) {
        const foundKey = Object.keys(options).find((key) => options[key].value === value);
        return foundKey != null ? options[foundKey] : null;
      }
      return null;
    }

    public valueChanged(field: any, id: any) {
      this.data[id] = field.value;
    }

    public inputSwitchChanged(field: { id: any, value: any }) {
      const key: string = field.id;
      // @ts-ignore-next-line
      this.data[key] = field.value;
    }

    public show(name: string) {
      switch (this.data.groupType) {
        case 'service':
          return ['productTerms', 'icon', 'address', 'partnerAgreementTypes'].includes(name);
        case 'certificate':
          return ['service'].includes(name);
        case 'recurringCommissionGroup':
          return ['service'].includes(name);
        case 'productGroup':
        case 'productSubGroup':
          return ['service', 'productTerms', 'foldable'].includes(name);
        case 'productClass':
          return ['service', 'productTerms'].includes(name);
        case 'restrict':
          return ['service'].includes(name);
        case 'exclude':
          return ['service', 'productTerms'].includes(name);
        default:
          return false;
      }
    }

    public remove(input: any, id: string) {
      if (this.data[id].includes(input.value)) {
        this.data[id] = this.data[id].filter((value: any) => {
          return value !== input.value;
        });
      }
    }

    public add(input: any, id: string) {
      if (!this.data[id].includes(input.value)) {
        this.data[id].push(input.value);
      }
    }

    public save() {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        this.$store.dispatch('setLoadOverlay', true);
        axios.post('/-/trade/api/settings.group.save', {
          id: this.$route.params.id,
          data: this.data,
        }).then(
          (response) => {
            this.$toast(this.$store.state.main.notification.messages.dataSaved);
          },
          (error) => {
            this.$toast(this.$store.state.main.notification.messages.couldNotSendData);
          },
        ).finally(() => {
          this.$store.dispatch('setLoadOverlay', false);
        });
      } else {
        this.$toast(createNotification(this.$v));
      }
    }

    public created() {
      this.$store.dispatch('setLoadOverlay', true);

      axios.post('/-/trade/api/settings.group.info', {
        id: this.$route.params.id,
        // TODO change id to not be hardcoded later
        providerId: this.$route.params.id ? undefined : 'c2c286fa-f280-4763-b306-81cef170d73b',
      }).then(
        (response) => {
          this.data = {...this.data, ...response.data.info};
          this.groupTypes = response.data.groupTypes;
          this.services = response.data.services;
          this.certificates = response.data.certificates;
          this.productTerms = response.data.productTerms;
          this.partnerAgreementTypes = response.data.partnerAgreementTypes;

          this.groupName = this.data.name;
        },
        (error) => {
          this.$toast(this.$store.state.main.notification.messages.couldNotReceiveData);
        },
      ).finally(() => {
        this.$store.commit('SET_SIDEMENU', this.sideMenu);
        this.$store.dispatch('setLoadOverlay', false);
      });
    }
  }
</script>

<style lang="scss" scoped>

</style>
